import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import MqttList from "./gmacList";
import { useState, useEffect } from "react";

function Logged() {
    // const [isLoading, setIsLoading] = useState(true);
    // useEffect(() => {}, []);

    const navigate = useNavigate();
    return (
        <>
            <div className="mb-5">Logged In</div>
            <div>
                <label className="p-2">add A new Gmac.</label>
                <button
                    onClick={() => navigate("/mqtt")}
                    type="button"
                    class="btn btn-primary ml-5"
                >
                    click
                </button>
            </div>
            <MqttList></MqttList>
        </>
    );
}

export default Logged;
